<template>
  <div id="navigation">
    
    <div class="vo-scrim" :class="{'active': $route.query.account || $route.query.activity }" @click="routeRemoveQueries(['account', 'activity'])"></div>

    <!-- ACCOUNT NAV -->
    <transition name="account-menu">
      <div class="account-menu" v-if="$route.query.account">
        <div class="option" v-ripple v-for="(option, i) in app.accountNav" :key="i" @click="optionClicked(option)">
          <div class="icon-item">
            <v-icon>{{ option.icon }}</v-icon>
          </div>
          <div class="name">{{ option.title }}</div>
        </div>
      </div>
    </transition>

    <!-- TOP NAV BAR -->
    <div class="nav-bar">

      <!-- DESKTOP NAV -->
      <div class="logo"></div>
      <div class="nav-items">
        <div v-ripple class="nav-item" v-for="(page, i) in app.navigation" @click="updatePage(page)" :key="i" :class="{'selected': isSelected(page)}" v-if="hasPermissions(page.permissions)">
          {{ page.title }}
        </div>
      </div>


      <div class="right-section">

        <!-- ACTIVITY BUTTON -->
        <div class="activity-button">
          
          <v-btn fab small flat @click="openKnowledgeBase">
            <v-icon medium class="icon">mdi-help-circle</v-icon>
          </v-btn>

          <v-btn fab small flat @click="toggle('activity')">
            <v-icon medium class="icon">mdi-bell</v-icon>
          </v-btn>

          <transition name="activity">
            <div v-if="$route.query.activity" name="account-menu" class="booper-nib"></div>
          </transition>
          
       
        </div>

        <!-- ACCOUNT DROPDOWN -->
        <div class="account" @click="toggle('account')">
          <vo-avatar class="avatar" :user="$store.getters.profile" :size="40"></vo-avatar>
          <div class="name">{{ $store.getters.profile.fullName }}</div>
          <div class="icon-item">
            <i class="mdi mdi-chevron-down mdi-36px" :class="{'mdi-flip-v': $route.query.account}"></i>
          </div>
        </div>

        <div class="clear"></div>
      </div>

    </div>

    <transition name="activity">
      <div v-if="$route.query.activity" class="activity-holder">
        <vo-activity></vo-activity>
      </div>
    </transition>

  </div>
</template>

<script>

  import navMixin from '../mixins/navMixin.js'
  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [navMixin, permissionMixin],
    data () {
      return {

      }
    },
    methods: {
      toggle (option) {
        if (this.$route.query[option]) this.routeRemoveQuery(option);
        else this.routeAddQuery(option);
      },

      openKnowledgeBase () {
        window.open(window.urls.knowledgeBase, '_blank');
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #navigation {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    
    .nav-bar {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 64px;
      pointer-events: auto;

      background: $primary;
      box-shadow: 0px 7px 4px -5px rgba(0,0,0,0.24);

      .logo {
        width: 100px;
        height: 64px;
        background-image: url('../assets/icons/favicon-96x96.png');
        background-size: 50px 50px;
        background-position: center center;
        background-repeat: no-repeat;
        float: left;
      }

      .nav-items {

        .nav-item {
          float: left;
          box-sizing: border-box;
          padding: 0 16px;
          line-height: 64px;
          user-select: none;

          @include fontPrimary500();

          font-size: 16px;
          color: $black54;
          text-transform: uppercase;
          letter-spacing: 0.4px;

          cursor: pointer;

          &.selected {
            color: $white;
            background: $white12;
          }    
        }
      } // .nav-items

      .account {
        float: right;
        line-height: 64px;
        background: $white12;
        border-left: 2px solid $white24;      
        height: 64px;
        cursor: pointer;
        user-select: none;

        .avatar {
          margin: 12px;
          float: left;
        }

        .name {
          
          @include fontPrimary400();
          @include textEllipsis();
          
          color: $white;
          max-width: 200px;

          float: left;
          margin: 0 12px 0 0;
        }

        .icon-item {
          float: left;
          color: $black54;    
          margin: 0 12px 0 0;
        }
      }
    }

    // Activity Button

    .right-section {
      float: right;
    }

    .activity-button {
      position: relative;
      float: left;
      margin: 6px 16px 0 0;

      .icon {
        color: $black54;
      }
    }

    .booper-nib {
      position: absolute;
      top: 55px;
      right: 13px;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 10px solid #FFF;
      transform: translate3d(0, 0, 0);
    }

    // Activity

    .activity-holder {
      position: absolute;
      top: 70px;
      right: 16px;
      width: 600px;
      height: 500px;
      background: $white;
      pointer-events: auto;
    }

    // Account Menu

    .account-menu {
      position: absolute;
      width: 200px;
      top: 64px;
      right: 0;
      border-radius: 0 0 2px 2px;
      overflow: hidden;
      pointer-events: auto;

      .option {
        background: $white;
        height: 45px;
        cursor: pointer;
        transition: $transitionHover;

        &:hover {
          background: #f1f1f1;
        }

        .icon-item {
          float: left;
          width: 50px;
          height: 24px;
          padding: 10px 16px 10px 10px;
          user-select: none;

          i {
            width: 24px;
            height: 24px;
            color: $black54;
          }
        }

        .name {
          @include fontPrimary400();
          line-height: 45px;
          float: left;
          color: $black87;
          user-select: none;
        }
      }
    }


    // Transition

    .account-menu-enter {
      transform: translate3d(0, -100%, 0);
    }

    .account-menu-enter-active {
      transition: all .3s ease;
    }

    .account-menu-leave-active {
      transition: all .3s ease;
      transform: translate3d(0, -100%, 0);
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue